import Vue from 'vue'
import { defineStore } from 'pinia'

export const STEPS = {
  name: 'name',
  description: 'description',
  budget: 'budget',
  contact: 'contact',
  location: 'location',
  options: 'options'
}

export const ALERTS = {
  spamming: 'spamming',
  awaiting: 'awaiting',
  success: 'success'
}

const resetableState = () => {
  return {
    lightMode: false,
    open: false,
    invitedProvider: null,
    step: null,
    alert: null,
    errors: {},
    progress: 0,
    stepProgresses: {},
    wellDescribed: null,
    needLocation: false,
    submitting: false,
    project: null,
    requestBody: { project: { user_attributes: {} } },
    resetable: false,
    closeConfirmation: false
  }
}

export const useMainStore = defineStore('main', {
  state: () => {
    return {
      ...resetableState(),
      source: null,
      content: null,
      spamming: false,
      pendingProjects: false,
      prefilledProjectTitle: null,
      user: {
        email: null,
        signedIn: false,
        country: null,
        phone: null,
        completeContactInfo: false,
        dailyProjectsQuota: null,
        zip: null,
        typology: 'guest'
      }
    }
  },
  actions: {
    reset() {
      for (const key in resetableState()) {
        this[key] = resetableState()[key]
      }
    },
    launch(source, options = {}) {
      const { invitedProvider, lightMode, project, prefilledProjectTitle } = options

      this.reset()
      this.setSource(source)

      if (invitedProvider && Object.keys(invitedProvider).length) {
        const expectedFields = ['slug']
        const hasEveryExpectedFields = expectedFields.every(field => Object.keys(invitedProvider).includes(field))
        if (!hasEveryExpectedFields) throw new Error('Invalid invitedProvider')

        this.invitedProvider = invitedProvider
        this.requestBody.user_slug = invitedProvider.slug
      }

      if (prefilledProjectTitle) {
        this.prefilledProjectTitle = prefilledProjectTitle
      }

      this.open = true

      if (lightMode) {
        this.lightMode = lightMode
        this.goToStep(STEPS.options)
        this.project = project
      } else if (this.spamming) {
        this.alert = ALERTS.spamming
      } else if (this.pendingProjects) {
        this.alert = ALERTS.awaiting
      } else {
        this.goToStep(STEPS.name)
      }
    },
    setSource(url) {
      const params = url.substring(url.indexOf('?') + 1).split('&')
      for (const param in params) {
        if (param.indexOf('source=') >= 0) {
          this.source = param.split('=')[1].trim()
        }
      }
    },
    changeCurrentStepProgress(progress) {
      Vue.set(this.stepProgresses, this.step, progress)
      this.progress = this.steps.indexOf(this.step) + (this.stepProgresses[this.step] || 100) / 100
    },
    goToNextStep() {
      const step = this.nextStep
      if (step === 'end') {
        // Submit project
      } else {
        this.backwardNavigation = false
        this.goToStep(step)
      }
    },
    goToPreviousStep() {
      this.backwardNavigation = true
      const step = this.previousStep
      if (step !== null) {
        this.goToStep(step)
      }
    },
    goToStep(step) {
      this.step = step
      this.progress = this.currentStepIndex + (this.stepProgresses[this.step] || 100) / 100
    },
    setProject(responseBody) {
      this.project = {
        id: responseBody.project_id,
        url: responseBody.project_url,
        state: responseBody.project_state,
        addOptionsUrl: responseBody.add_options_url,
        resendConfirmationUrl: responseBody.confirmation_url
      }
      this.resetable = true
    }
  },
  getters: {
    steps(state) {
      let steps = [...Object.values(STEPS)]
      if (!state.needLocation) steps = steps.filter(step => step !== STEPS.location)
      return steps
    },
    stepsCount() {
      return this.steps.length - 1
    },
    stepContent: state => step => {
      return state.content.steps[step]
    },
    currentStepContent(state) {
      if (!state.content) return null

      return state.content.steps[state.step] || {}
    },
    currentStepIndex(state) {
      return this.steps.indexOf(state.step) || 0
    },
    nextStep() {
      const step = this.steps[this.currentStepIndex + 1]
      return typeof step === 'undefined' ? null : step
    },
    previousStep() {
      const step = this.steps[this.currentStepIndex - 1]
      return typeof step === 'undefined' ? null : step
    }
  }
})
